import { SET_ALERT, REMOVE_ALERT } from "../types";
import { v4 as uuid } from "uuid";
import { handleError } from "./error";
import Axios from "axios";
import { handleResponse } from "./response";
import { socket } from "../../helpers/bootstrap";
function toString(value) {
    return value.toString();
}

function compareMsg(a, b) {
    return toString(a) === toString(b);
}
function compareId(a, b) {
    return toString(a) === toString(b);
}
export const setAlert = (msg, alertType, id, alertCode) => (
    dispatch,
    getState
) => {
    try {
    //  use existing id rather than generate a new one
        const alertId = id ? id : uuid();
        const { alert, contacts } = getState();
        //  Prevent from submitting many same alerts
        if (
            alert.some(
                a => compareMsg(a.msg, msg) || compareId(a.alertId, alertId)
            )
        ) {
            return;
        }

        const payload = {
            msg,
            alertType,
            alertId,
            alertCode,
            alertTime: Date.now()
        };
        //  Override lockdown alert
        if (alertCode === "lockdown") {
            payload.alertType = "system";
        }

        //  Save to session
        socket.emit("SET_ALERT_LOG", {
            user_id: contacts.contact.user_id,
            log: payload
        });

        dispatch({
            type: SET_ALERT,
            payload
        });
        if (!["error", "system"].includes(payload.alertType)) {
            setTimeout(() => dispatch(removeAlert(payload.alertId)), 10000);
        }
    }
    catch (error) {
        if (process.env.NODE_ENV !== "test") {
            console.debug("Alert box error!");
        }
    }
};

export const submitUserReport = formData => async(dispatch, getState) => {
    try {
        const { error: { error } } = getState();

        const response = await Axios.post("/user_reports/write", {
            ...formData,
            error
        });

        dispatch(handleResponse(response));
    }
    catch (error) {
        dispatch(handleError(error));
    }
};

export const removeAlert = id => async dispatch => {
    try {
        dispatch({
            type: REMOVE_ALERT,
            payload: id
        });
    }
    catch (error) {
        console.log(error);
    }
};